import React, { useEffect, useState } from 'react'
import styles from "../MetaField.module.scss"
import { CustomDropdown } from 'components/shared/customDropdown'
import { TextField } from '@mui/material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useDispatch, useSelector } from 'react-redux';
import { setDroppedItems } from 'redux/slices/triggerSlice';
import { FormSelectReccuringProjectContainer } from 'components/pages/tasks/components/FormSelectReccuringProjectContainer';
import { setPublish } from 'redux/slices/globalSlice';
const options = [
    {
        label: "is", value: "is"
    },
    {
        label: "is not", value: "is not"
    }
]
const Project = ({
    item
}) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger)
    const dispatch = useDispatch()
    const [localOptions, setLocalOptions] = useState({
            label: "Project", options: item?.operator || "is",
            value: item?.value[0] || [],
            valueLabel: item?.valueLabel || "",
        });
    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id)
        dispatch(setDroppedItems(filteredDroppedItems))
        dispatch(setPublish(true))
    }
    // const handleChange = (name, value) => {
    //     const updatedTriggerList = triggerDroppedList?.map((e) => {
    //         return e?.id == item?.id ? {
    //             ...e,
    //             options: [
    //                 {
    //                     ...e?.options[0],
    //                     label: "Project",
    //                     [name]: value
    //                 }
    //             ]

    //         } : e
    //     })
    //     dispatch(setDroppedItems(updatedTriggerList))
    // }

    const handleChange = (name, value, valueLabel) => {
        setLocalOptions((prev) => {
            let updatedOptions;

            if (name === "value") {
                // Ensure value is always an array
                updatedOptions = { ...prev, [name]: Array.isArray(value) ? value : [value], valueLabel : valueLabel || "" };
            } else {
                updatedOptions = { ...prev, [name]: value };
            }
            return updatedOptions;
        });
    };
    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Project",
                    valueLabel: localOptions?.valueLabel || "",
                    value: localOptions?.value || [],
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);
   

    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            ...(item?.value ? {
                value: item?.value
            } : {}),
        }));
    }, [item?.operator, item?.value]);
    return (
        <>
            <div className={styles?.metaContainer}>
                <div className={styles?.field}>
                    <TextField value={"Project"} disabled={true} />
                    <CustomDropdown
                        options={options}
                        width='200px'
                        value={localOptions?.options}
                        onChange={(e) => {
                            handleChange(e?.target?.name, e?.target.value)

                        }} name="options" />
                    <FormSelectReccuringProjectContainer
                        value={localOptions?.value}
                        handleChange={(name, option) => handleChange(name, option?.value, option?.label)}
                        name="value"
                        width='175px'
                        isTriggerOption={true}
                        customStyles={{
                            marginTop: "0px !important",
                            "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                                paddingBottom: "3px",
                                paddingTop: "4.5px"
                            }
                        }}
                        defaultValue={item?.valueLabel && {
                            label: item?.valueLabel,
                            value: item?.value
                        }}
                    />
                </div>

                <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={handleDelete}>
                    <HighlightOffIcon />
                </div>



            </div>
        </>
    )
}

export default Project